import { StackPanel } from '@agilepoint/wat-react-ux';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { ReactComponent as NotFoundIllustration } from '../../../assets/svg/not-found-illustration.svg';

const IllustrationWrapper = styled.div`
    width: 70%;
    text-align: center;
    box-shadow: 0px 0px 8px 8px #ccc;
    padding: 16px 12px 2px;
`;

const Message = styled.div`
    font-size: 22px;
    font-weight: 300;
`;

export function SessionOutPage() {
    const { pathname, search } = useLocation();

    return (
        <StackPanel orientation="horizontal" width="100%" height="100%" justifyContent="center" alignment="center">
            <IllustrationWrapper>
                <Message>Your session has expired. Please click here to <Link to="/login" state={{ previousCompletePath: `${pathname}${search}` }}>Login</Link></Message>
                <NotFoundIllustration />
            </IllustrationWrapper>
        </StackPanel>
    );

}
